import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { createRequestOption } from '../common/utils/request-util';

@Injectable({ providedIn: 'root' })
export class BusinessOperationsService {

  constructor(
    private http: HttpClient,
  ) {}

  queryUsersList(body) {
    return this.http.post(environment.urlBackEnd + 'agency/user/list/', body);
  }
  getInfoAgency(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'agency-partner/' + req.id,  {  params: options, observe: 'response' });
  }
  updateShareStatus(body) {
    return this.http.put(environment.urlBackEnd + 'agency-admin/agency-partner/' + body.id + '/update-share-status', body);
  }
  getInfoAgencyFormAdmin(id) {
    return this.http.get(environment.urlBackEnd + `agency-admin/agency-partner/${id}/detail`);
  }
  queryAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/agency-partner/list/', body);
  }
  createAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-partner/', body);
  }
  updateAgency(body) {
    return this.http.put(environment.urlBackEnd + 'agency-partner/' + body.id, body);
  }
  approveAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/' + body.id + '/approve-partner-to-consultant', body);
  }
  rejectAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/' + body.id + '/reject-partner-to-consultant', body);
  }
  queryOrder(body) {
    return this.http.post(environment.urlBackEnd + 'agency/order/list/', body);
  }
  queryListFee(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/list-fee/', body);
  }
  queryListTrailerFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/agency-partner/' + body.id + '/list-fee/', body);
  }
  exportListTrailerFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/agency-partner/' + body.id + '/export-fee/', body, { responseType:'blob', observe: 'response' });
  }
  queryListTransactionFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/transaction-fee/list', body);
  }
  exportListTransactionFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/transaction-fee/export', body, { responseType:'blob', observe: 'response' });
  }
  exportFeeListPartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/export-transfer-partner-claim-request', body,  { observe: 'response' });
  }
  createWithdrawalFee(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/create-claim-request/', body);
  }
  queryListFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/list-organization-fee/', body);
  }
  queryListTransactionFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/transaction-fee/list', body);
  }
  queryListWithdrawalFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/list-organization-claim-request/', body);
  }
  exportListWithdrawalFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/export-transfer-partner-claim-request/', body, { responseType:'blob', observe: 'response' });
  }
  queryListWithdrawalFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/list-partner-claim-request/', body);
  }
  confirmWithdrawalFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/' + body.id + '/confirm-payment-organization-claim-request/', body);
  }
  confirAllmWithdrawalFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/confirm-payment-all-partner-claim-request/', body);
  }
  getIssuer(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/organization/list/', body,  { observe: 'response' });
  }
  findOrganization(id: number) {
    return this.http.get<any>(`${environment.urlBackEnd}agency-admin/organization/${id}`, { observe: 'response' });
  }
  createOranization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/organization/', body);
  }
  updateOranization(body) {
    return this.http.put(environment.urlBackEnd + 'agency-admin/organization/' + body.id, body);
  }
  deleteOrganization(id: number){
    return this.http.delete(`${environment.urlBackEnd}agency-admin/organization/${id}/`);
  }
  getOranizations(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/organization/list/', body);
  }
  exportFeeListOranization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/export-organization-fee/', body,  { responseType:'blob', observe: 'response' });
  }
  exportTransactionFeeListOranization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/transaction-fee/export', body,  { responseType:'blob', observe: 'response' });
  }
  getIssuerForPendingPayment(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/organization-have-partner-claim-request/', body);
  }
  uploadTrialFile(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/upload-trial-time', body,  { responseType:'blob', observe: 'response' });
  }
  queryListTrialAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/agency-partner-trial/list/', body);
  }
  updateTrialAgency(body) {
    return this.http.put(environment.urlBackEnd + 'agency-admin/agency-partner-trial/' + body.id + '/update', body);
  }
  acceptCooperate(body) {
    return this.http.post(environment.urlBackEnd + `agency-admin/agency-partner/${body.id}/approve-sign-contract`, body);
  }
  denyCooperate(body) {
    return this.http.post(environment.urlBackEnd + `agency-admin/agency-partner/${body.id}/reject-sign-contract`, body);
  }

  acceptAllClaimRequest(body) {
    return this.http.post(environment.urlBackEnd + `agency-admin/accept-all-partner-claim-request/`, body);
  }
  denyClaimRequest(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/cancel-partner-claim-request/'  + body.id, body);
  }
  exportClaimPartnerRequest1(body) {
    return this.http.post(environment.urlBackEnd + `agency-admin/export-claim/${body.claimId}/`, body,  { responseType:'blob', observe: 'response' });
  }
  exportClaimPartnerRequest2(body) {
    return this.http.post(environment.urlBackEnd + `agency-admin/export-claim/${body.claimId}/trailer-fee-statement/`, body,  { responseType:'blob', observe: 'response' });
  }
  exportClaimOrgRequest(body) {
    return this.http.post(environment.urlBackEnd + `agency-admin/export-organization-claim/${body.claimId}/`, body,  { responseType:'blob', observe: 'response' });
  }
  addContract(body, id) {
    return this.http.put(environment.urlBackEnd + 'agency-admin/add-contract/'  + id, body);
  }
  exportTaxDocument(body) {
    return this.http.post(environment.urlBackEnd + 'agency-admin/export-tax-document/', body,  { responseType:'blob', observe: 'response' });
  }
  queryRatingList(body) {
    return this.http.post(environment.urlBackEnd + 'agency/list-consulting-rating/', body);
  }
  statisticRating(body) {
    return this.http.post(environment.urlBackEnd + 'agency/average-consulting-rating/', body);
  }
}
